import { cn } from '@/lib/utils';
import type { Tone } from './Badge';

const FILL: Record<Tone, string> = {
  neutral: 'bg-muted-foreground',
  info: 'bg-info',
  ok: 'bg-success',
  pending: 'bg-info',
  warn: 'bg-warning',
  serious: 'bg-serious',
  crit: 'bg-critical',
};

/** A ratio against a limit, with an optional target tick marking the objective. */
export function Meter({ value, tone, target, label }: { value: number | null; tone: Tone; target?: number; label: string }) {
  const pct = value === null ? 0 : Math.min(100, Math.max(0, value * 100));
  return (
    <div
      className="relative h-2 w-full overflow-hidden rounded-full bg-muted"
      role="meter"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={value === null ? undefined : Number(pct.toFixed(1))}
    >
      <div className={cn('h-full rounded-full transition-all', FILL[tone])} style={{ width: `${pct}%` }} />
      {target !== undefined ? (
        <div className="absolute top-0 h-full w-0.5 bg-foreground/60" style={{ left: `${target * 100}%` }} title={`Target ${(target * 100).toFixed(1)}%`} />
      ) : null}
    </div>
  );
}
